<template>
  <div id="overlay" v-show="showContent" v-on:click.self="closeModal">
    <div id="content" class="action-close quest-container">
      <div id="quest-detail">
        <div class="quest-title">
          <div :class=typeClass(quest.quest_type) class="quest-type">{{quest.quest_type_name}}</div>
          <div :class=periodClass(quest.quest_period) class="quest-period">{{quest.quest_period_name}}</div>
          <div class="achieved-tag">
            <input type="checkbox" :id=this.achievedId(quest.quest_id) name=item.quest_name v-model=achieved>
            <label :for=this.achievedId(quest.quest_id) class="achieved-tag-label">達成</label>
          </div>
          <div class="quest-name">{{quest.name}}</div>
        </div>
        <div class="tool-aria">
          <x-button :quest="quest"></x-button>
          <google-button :quest="quest"></google-button>
          <template>
            <div>
              <CopyUrlButton />
            </div>
          </template>
        </div>
        <div class="quest-description-container">
          <div class="quest-description">{{quest.description}}</div>
          <div v-if="quest.end_datetime!==null" class="quest-startend-finished">終了済任務</div>
          <div v-else-if="quest.is_limited===1" class="quest-startend-limited">期間限定！</div>
          <div v-bind:class="{'quest-startend-finished': quest.end_datetime!==null}">実装期間：{{quest.start_datetime}} ～ {{quest.end_datetime}}</div>
          <div class="quest-conditions">
            <div class="conditions-title">達成条件</div>
            <div class="conditions-detail">{{quest.detail}}</div>
            <div v-if="(quest.quest_type==='sortie' || quest.quest_type==='exercise' || quest.quest_type==='arsenal')" class="conditions-sentence">
              <div v-if="quest.ship.length!==0" >
                <div class="conditions-title">指定艦娘</div>
                <div class="conditions-list" v-for="(item, key) in quest.ship" :key="key">
                  {{item.name}}
                </div>
              </div>
              <div v-if="(quest.quest_type==='sortie' || quest.quest_type==='exercise')">
                <div class="conditions-title">対象海域</div>
                <div class="conditions-list" v-for="(item, key) in quest.area" :key="key">
                  <div v-for="(area, key) in item.area" :key="key">
                    - <span>{{area.area_detail}}</span>
                  </div>
                  <span v-if="item.rank_count_condition!==''">{{item.rank_count_condition}}</span>
                </div>
              </div>
            </div>
            <div v-else-if="quest.quest_type==='expedition'" class="conditions-sentence">
              <div class="conditions-title">対象遠征</div>
              <div class="conditions-list" v-for="(item, key) in quest.expedition" :key="key">
                <!-- ensei_id=00は 任意の遠征 となるためidを非表示 -->
                <span v-if="item.ensei_id != '00'">{{item.ensei_id}} : </span>{{item.ensei_name}} <span v-if="item.ensei_time != null">({{item.ensei_time}}) </span>{{item.count}} 回
              </div>
            </div>
          </div>
          <div class="quest-reward">
            <div class="reward-title">報酬</div>
            <div class="reward-base" v-for="(item_base, key) in quest.reward_base" :key="key">
              <div>燃料：{{item_base.nenryo}}</div>
              <div>弾薬：{{item_base.danyaku}}</div>
              <div>鋼材：{{item_base.kozai}}</div>
              <div>ボーキサイト：{{item_base.bauxite}}</div>
            </div>
            <div class="reward-sentence" v-for="(item_other, key) in quest.reward_other" :key="key">
              <div v-if="item_other.bonus_type===0" class="reward-title">確定報酬</div>
              <div v-else class="reward-title">選択報酬 {{item_other.bonus_type}}</div>
              <div class="reward-list" v-for="(item, key) in item_other.items" :key="key">
                <span v-if="item.item_type==='1'">{{item.item_name}}<span v-if="item.modding_point!==0"> ★{{item.modding_point}}</span> × {{item.count}}</span>
                <span v-else-if="item.item_type==='2'">{{item.item_name}} × {{item.count}}</span>
                <span v-else-if="item.item_type==='3'">艦娘『 {{item.item_name}} 』</span>
                <span v-else-if="item.item_type==='4'">家具『 {{item.item_name}} 』</span>
                <span v-else-if="item.item_type==='5'">{{item.item_name}} を開放</span>
              </div>
              <div v-if="item_other.bonus_type!==0" class="reward-list">上記から選択</div>
            </div>
          </div>
        </div>
      </div>
      <div id="quest-flow">
        <div id="prerequisite-quest">
          <div class="presub-quest-title">
            前提
          </div>
          <div class="presub-quest-list">
            <div class="presub-quest-panel" v-for="(item, key) in quest.prerequisite_quest" :key="key"
                 v-bind:style="{background:backgroundColor(item.quest_type)}">
              <router-link :to="'/quest/'+item.quest_id">
                <a v-on:click="setModalQuest(item.quest_id)"
                v-bind:style="{color:textColor(item.quest_period)}"
                >{{item.name}}</a>
              </router-link>
            </div>
          </div>
        </div>
        <div id="subsequent-quest">
          <div class="presub-quest-title">
            後続
          </div>
          <div class="presub-quest-list">
            <div class="presub-quest-panel" v-for="(item, key) in quest.subsequent_quest" :key="key"
                 v-bind:style="{background:backgroundColor(item.quest_type)}">
              <router-link :to="'/quest/'+item.quest_id">
                <a v-on:click="setModalQuest(item.quest_id)"
                  v-bind:style="{color:textColor(item.quest_period)}"
                >{{item.name}}</a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <button class="btn" v-on:click="closeModal">×</button>
    </div>
  </div>
</template>

<script>

import QuestModalMixin from './QuestModalMixin'

export default {
  mixins: [QuestModalMixin]
}
</script>

<style scoped>
ul {
  list-style-type: none;
}
a {
  text-decoration:none;
}
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.6);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;

}
#content{
  z-index:2;
  background-color:#F4EAE0;
  width: 100%;
  height: 680px;
  border: 2px solid;
  border-image: linear-gradient(to top, #877325, #C0B578);
  border-image-slice:1;
  display: block;
}
.btn {
  color: #FFFFFF;
  font-size: 20pt;
  background-color: #393836;
  padding: .3em .5em;
  text-align: center;
  cursor: pointer;
}
.btn:hover {
  cursor: pointer;
}
/* close button */
.action-close {
  position: relative;
  margin-top: 2em;
}
.action-close .btn {
  position: absolute;
  right: 0;
  top: -1em;
}

.quest-container {
  display: flex;
}
#quest-flow {
  display: flex;
  height: 240px;
}
#prerequisite-quest, #subsequent-quest {
  width: 260px;
}
.presub-quest-title {
  background-color: #393836;
  color: #FFFFFF
}
.tool-aria {
  display: flex;
  justify-content: flex-end;
}
.presub-quest-list {
  height: 100%;
  overflow: auto;
}
.presub-quest-panel {
  position: relative;
  background-color: #E5D5C4;
  display: flex;
  height: 60px;
  padding: 2px 2px;
  margin: 6px;
  text-align: left;
  color: #67615B;
  overflow-y: hidden;
  font-weight: bold;
  text-shadow: 1px 1px 0 #393836, -1px 1px 0 #393836, 1px -1px 0 #393836, -1px -1px 0 #393836;
}
.presub-quest-panel:hover {
  cursor: pointer;
  background-color: #E1CFBB;
}
#quest-detail {
  border-right: 1px solid;
  border-left: 1px solid;
  border-image: linear-gradient(to bottom right, #333333, #A3A3A3);
  border-image-slice: 1;
  width: 100%;
  height: 440px;
  overflow: auto;
}
.quest-type {
  height: 48px;
  width: 48px;
  line-height: 48px;
  font-size: 16pt;
  color: #FFFFFF;
  text-shadow: 0 0 4px var(--outline-color); /* フォントの影を指定 */
  font-weight: bold;
  -webkit-text-stroke: 1px var(--outline-color); /* フォントのアウトラインを指定 */
  border: 1px solid #484226;
  margin-right: 4px;
}
/* TODO:モーダルでも同じスタイルを使用しているため共通化したい */
.quest-type-factory {
  background-image: linear-gradient(to bottom, #56C16C, #3F7A4D);
  --outline-color: #153018;
}
.quest-type-sortie {
  background-image: linear-gradient(to bottom, #F26C6D, #B93B38);
  --outline-color: #6C120F;
}
.quest-type-exercise {
  background-image: linear-gradient(to bottom, #9CD073, #479334);
  --outline-color: #1E3813;
}
.quest-type-expedition {
  background-image: linear-gradient(to bottom, #50C6C5, #369B96);
  --outline-color: #052F2E;
}
.quest-type-supply_repair {
  background-image: linear-gradient(to bottom, #E2C873, #BF9B3F);
  --outline-color: #5B3D21;
  line-height: 24px;
}
.quest-type-arsenal {
  background-image: linear-gradient(to bottom, #946B50, #62423A);
  --outline-color: #1F0E09;
}
.quest-type-refurbishment {
  background-image: linear-gradient(to bottom, #D5AEE2, #A27EB4);
  --outline-color: #593C68;
}
.quest-period{
  height: 48px;
  width: 48px;
  line-height: 48px;
  font-size: 16pt;
  text-shadow: 0 0 4px var(--outline-color); /* フォントの影を指定 */
  font-weight: bold;
  -webkit-text-stroke: 1px var(--outline-color); /* フォントのアウトラインを指定 */
  background-image: linear-gradient(to bottom, #D0D2D2, #B5B7B7);
  border: 1px solid #484226;
  margin-right: 4px;
}
/* TODO:モーダルでも同じスタイルを使用しているため共通化したい */
.quest-period-daily {
  color: #71BFFD;
  --outline-color: #24364D;
}
.quest-period-weekly {
  color: #74D4E0;
  --outline-color: #2F5565;
}
.quest-period-monthly {
  color: #B7E161;
  --outline-color: #243F33;
}
.quest-period-quarterly {
  color: #DF9B61;
  --outline-color: #40382B;
}
.quest-period-yearly {
  color: #FFFFFF;
  --outline-color: #292725;
}
.quest-period-once {
  color: #EED952;
  --outline-color: #41433A;
}
.quest-title {
  color: #FFFFFF;
  font-size: 14pt;
  background-image: linear-gradient(to bottom, #444444, #2A2A2A);
  margin: 4px;
  padding: 2px;
  display: flex;
}
.quest-name {
  flex: 1;
  text-align: left;
}
.quest-description-container {
  height: 100%;
  overflow: auto;
}
.quest-description {
  margin: 14pt;
  text-align: left;
}
.quest-startend-finished {
  color: #e03333;
  background-color: #afafaf;
  font-weight: bold;
}
.quest-startend-limited {
  color: #ffffff;
  background-color: #e03333;
  font-weight: bold;
}
.quest-conditions {
  border: 1px solid;
  border-image: linear-gradient(to bottom right, #333333, #A3A3A3);
  border-image-slice: 1;
  margin: 8px;
}
.conditions-title {
  background-color: #333333;
  color: #FFFFFF;
}
.conditions-detail {
  text-align: left;
  white-space: pre-wrap;
  margin: 10px;
  border-width: 1px;
}
.conditions-list {
  margin: 4px;
}
.conditions-sentence {
  margin: 10px;
  border: solid;
  border-width: 1px;
}
.quest-reward {
  border: 1px solid;
  border-image: linear-gradient(to bottom right, #333333, #A3A3A3);
  border-image-slice: 1;
  margin: 8px;
}
.reward-title {
  background-color: #333333;
  color: #FFFFFF;
}
.reward-base {
  display: flex;
  justify-content: space-around;
  margin: 8px;
  margin-left: 15%;
  margin-right: 15%;
}
.reward-list {
  margin: 4px;
}
.reward-sentence {
  margin: 10px;
  border: solid;
  border-width: 1px;
}
.achieved-tag {
  z-index: 1;
}
.achieved-tag-label { /* フィルタの基本デザイン：オフ */
  display: block; /* ブロックレベル要素化する */
  float: left; /* 要素の左寄せ・回り込を指定する */
  font-size: 14pt;
  font-weight: bold;
  width: 56px;
  height: 28px;
  margin: 4px;
  border-radius: 12px;
  text-align: center; /* テキストのセンタリングを指定する */
  cursor: pointer; /* マウスカーソルの形（リンクカーソル）を指定する */
  color: #898989; /* フォントの色を指定 */
  background: #393836;
}
input[type=checkbox] {
  display: none;
}
.achieved-tag > input[type="checkbox"]:checked + label {
  color: #FFFFFF;
  cursor: pointer;
  background-image: linear-gradient(to bottom, #229697, #22e597);
  border-left-color: #56C16C;
  border-right-color: #3F7A4D;
  --outline-color: #153018;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestModalSm.vue